/** Retain failed rows for retry without repeating already completed operations. */
export async function runBotBatch<T extends { _id: string }>(bots: readonly T[], action: (id: string, item: T) => Promise<unknown>, concurrency = 1) {
  const succeeded = new Set<string>();
  const failed: T[] = [];
  // Workers share one iterator, so each bot is processed exactly once.
  const queue = bots[Symbol.iterator]();
  const worker = async () => {
    for (const bot of queue) {
      try {
        await action(bot._id, bot);
        succeeded.add(bot._id);
      } catch {
        failed.push(bot);
      }
    }
  };
  await Promise.all(Array.from({ length: Math.min(Math.max(1, concurrency), bots.length) }, worker));
  return { succeeded, failed };
}
